// extracted by mini-css-extract-plugin
module.exports = {"image":"Image_image__0Q9Uw","rounded":"Image_rounded__Jxo_G","content":"Image_content__qVpPx"};